import { type MediaType } from '@/services/strapiSchema';

interface CmsImageProps {
  media: MediaType;
  sizes: string;
  /** Image LCP (au-dessus de la ligne de flottaison) : chargement immédiat et prioritaire. */
  priority?: boolean;
  alt?: string;
  className?: string;
  width?: number;
  height?: number;
}

function CmsImage({
  media,
  sizes,
  priority = false,
  alt,
  className,
  width: widthOverride,
  height: heightOverride,
}: CmsImageProps) {
  const altText = alt ?? media.alternativeText ?? '';
  const loading: 'eager' | 'lazy' = priority ? 'eager' : 'lazy';
  const fetchPriority: 'high' | undefined = priority ? 'high' : undefined;
  const { variants } = media;

  const width = widthOverride ?? media.width ?? variants?.width ?? undefined;
  const height = heightOverride ?? media.height ?? variants?.height ?? undefined;

  const cmsImg = (
    src: string,
    responsive?: { srcSet: string; sizes: string },
  ) => (
    <img
      src={src}
      srcSet={responsive?.srcSet}
      sizes={responsive?.sizes}
      alt={altText}
      width={width}
      height={height}
      className={className}
      draggable={false}
      loading={loading}
      fetchPriority={fetchPriority}
      decoding="async"
    />
  );

  if (!variants) {
    return cmsImg(media.url);
  }

  return (
    <picture>
      {variants.avif ? <source type="image/avif" srcSet={variants.avif} sizes={sizes} /> : null}
      {cmsImg(variants.src, { srcSet: variants.webp, sizes })}
    </picture>
  );
}

export default CmsImage;
